import Axios from "./axios";

const resource = "home-sliders";

export default {
  get() {
		return Axios.get(`${resource}`);
	}
}